module.exports = __webpack_public_path__ + "static/img/retu.2218462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/retu.png
// module id = Sgyh
// module chunks = 0